export default __webpack_public_path__ + "img/eEimpfaz.e407e6f2.svg";